export default __webpack_public_path__ + "static/compareItemImg5-eabf216c32ac3ff5617ab51775f680de.webp";